export default __webpack_public_path__ + "static/media/Corpay x Alpha LockUp_Spanish - Corporate - Vertical - White.acfcf113.svg";